<template>
    <div class="d-flex align-items-center gap-5">
        <div class="w-50 downloadCatalogueSection">
            <h2 class="mb-60">
                <span class="span-background">Notre catalogue de formation</span>
            </h2>
            <p class="pb-3">
                Découvrez le programme détaillé de nos formations
            </p>
            <div>
                <a class="btn-orange-outline d-flex gap-3 align-items-center mobile" :href="pdf" target="_blanks">
                    <i>
                        <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.4375 19.4874L1.6875 12.7374C1.40625 12.4561 1.40625 11.9405 1.6875 11.6592C1.96875 11.378 2.48438 11.378 2.76562 11.6592L8.25 17.1436V3.17487C8.25 2.79987 8.57812 2.42487 9 2.42487C9.375 2.42487 9.75 2.79987 9.75 3.17487V17.1436L15.1875 11.6592C15.4688 11.378 15.9844 11.378 16.2656 11.6592C16.5469 11.9405 16.5469 12.4561 16.2656 12.7374L9.51562 19.4874C9.375 19.628 9.1875 19.6749 9 19.6749C8.76562 19.6749 8.57812 19.628 8.4375 19.4874ZM17.25 21.9249C17.625 21.9249 18 22.2999 18 22.6749C18 23.0967 17.625 23.4249 17.25 23.4249H0.75C0.328125 23.4249 0 23.0967 0 22.6749C0 22.2999 0.328125 21.9249 0.75 21.9249H17.25Z" />
                        </svg>
                    </i>
                    <span>Téléchargez le catalogue</span>
                </a>
            </div>
        </div>
        <div class="w-50">
            <nuxt-img src="/images/pages/organisme-formation/download-catalogue.jpeg"></nuxt-img>
        </div>
    </div>
</template>

<script setup>
import axios from 'axios';

const pdf = ref('');
onMounted(async () => {
    try {
        const response = await axios({
            method: 'post',
            url: 'https://ws2-gbbu02.graphibox.eu/EpDirectories.ws',
            data: { pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872', pFct: 'GetDirectories', pIdCat: '69' },
        });
        const files = response.data[0];
        pdf.value = `https://cdn-gbbu02.graphibox.eu/pub/${files.siteIdD}/medias/directories/${files.idD}/${files.file1D}`;
    } catch (error) {
        console.error('Erreur lors du chargement des données :', error);
    }
});

</script>

<style scoped>
h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

p {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

a {
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    /* 27px */
    letter-spacing: 0.8px;
}

.downloadCatalogueSection {
    margin-left: 100px;
}

svg {
    fill: #000;
    transition: all 0.4s;
}

.btn-orange-outline:hover i svg {
    fill: white;
}

.btn-orange-outline {
    width: 50%;
}

span {
    white-space: nowrap;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
    .d-flex {
        flex-direction: column-reverse;
        width: 100%;
        padding: 10px 10px;
    }

    h2 {
        font-size: 1.469rem !important;
    }

    .w-50 {
        width: 90% !important;
    }

    .downloadCatalogueSection {
        margin-left: unset;
    }

    .mobile {
        flex-direction: row !important;
    }

    span {
        text-transform: uppercase;
        white-space: normal;
    }
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media screen and (min-width: 1200px) and (max-width: 1441px) {

    .btn-orange-outline {
        width: 60%;
    }

    h2 {
        font-size: 45px;
    }
}
</style>